export default "__VITE_ASSET__DYSryY0w__"